import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './styles.css'
import { installUniverNoteAutosize } from './lib/univer-note-autosize'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'



const app = createApp(App)
installUniverNoteAutosize()
app.use(router)  // 注册路由插件
app.use(ElementPlus)
app.mount('#app')